import { render, staticRenderFns } from "./canada-fund-stock-level-attribution-panel.vue?vue&type=template&id=ff3e2738&"
var script = {}
import style0 from "./canada-fund-stock-level-attribution-panel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports